module.exports = __webpack_public_path__ + "img/luottorahoitus@2x.81fde12.png";